import React from "react";
import { BsThreeDots } from "react-icons/bs";

const AdminContent = () => {
  return (
    <>
      <div className="my-5">
        <table class="table bg-white rounded shadow overflow-hidden">
          <thead className="text-secondary ">
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Subject</th>
              <th scope="col">Trigger</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Verification</td>
              <td>Verify Account</td>
              <td>Create Account</td>
              <td>
                <button className="btn btn-secondary">
                  <BsThreeDots />
                </button>
              </td>
            </tr>
            <tr>
              <td>Welcome</td>
              <td>Welcome to Villa</td>
              <td>Start Membership</td>
              <td>
                <button className="btn btn-secondary">
                  <BsThreeDots />
                </button>
              </td>
            </tr>
            <tr>
              <td>Password Reset</td>
              <td>Password Reset</td>
              <td>Forgot Password</td>
              <td>
                <button className="btn btn-secondary">
                  <BsThreeDots />
                </button>
              </td>
            </tr>
            <tr>
              <td>Password Changed</td>
              <td>Password Changed</td>
              <td>New Password</td>
              <td>
                <button className="btn btn-secondary">
                  <BsThreeDots />
                </button>
              </td>
            </tr>
            <tr>
              <td>Membership Canceled</td>
              <td>Membership Canceled</td>
              <td>Cancel Membership</td>
              <td>
                <button className="btn btn-secondary">
                  <BsThreeDots />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
};

export default AdminContent;
